export const marqueeCredentials = [
  {
    href: '/credentials/outsourcing-service-provider-iso9001.pdf',
    src: '/images/cred-iso9001.svg',
    alt: 'ISO 9001 Bureau Veritas Certification',
    width: 150,
    height: 34,
  },
  {
    href: '/credentials/outsourcing-service-provider-iso27001.pdf',
    src: '/images/credentials/ISO-27001-Logo.webp',
    alt: 'ISO 27001 Bureau Veritas Certification',
    width: 120,
    height: 34,
  },
  {
    href: '',
    src: '/images/cred-nasscom.svg',
    alt: 'NASSCOM Member',
    width: 120,
    height: 34,
  },
  {
    href: '',
    src: '/images/cred-stpi.svg',
    alt: 'STPI',
    width: 100,
    height: 34,
  },
  {
    href: '',
    src: '/images/cred-cii.svg',
    alt: 'CII – Confederation of Indian Industry',
    width: 140,
    height: 34,
  },
  // {
  //   href: '',
  //   src: '/images/credentials/GDPR-Logo.webp',
  //   alt: 'GDPR Compliant',
  //   width: 35,
  //   height: 34,
  // },
  // {
  //   href: '',
  //   src: '/images/credentials/CCPA-Logo.webp',
  //   alt: 'CCPA Compliant',
  //   width: 34,
  //   height: 34,
  // },
  // {
  //   href: '',
  //   src: '/images/credentials/DPDP-Logo.webp',
  //   alt: 'DPDP Certified',
  //   width: 34,
  //   height: 34,
  // },
  // {
  //   href: '',
  //   src: '/images/credentials/HIPAA-Logo.webp',
  //   alt: 'HIPAA Compliance',
  //   width: 64,
  //   height: 34,
  // },
];

export const credentials = [
  {
    key: 'iso27001',
    src: '/images/credentials/ISO-27001-Logo.webp',
    alt: 'ISO 27001 Certified',
    href: '/credentials/outsourcing-service-provider-iso27001.pdf',
  },
  {
    key: 'nasscom',
    src: '/images/cred-nasscom.svg',
    alt: 'NASSCOM Member',
    href: '',
  },
  {
    key: 'cii',
    src: '/images/cred-cii.svg',
    alt: 'CII Member',
    href: '',
  },
  {
    key: 'stpi',
    src: '/images/cred-stpi.svg',
    alt: 'STPI Registered',
    href: '',
  },
  {
    key: 'iso9001',
    src: '/images/cred-iso9001.svg',
    alt: 'ISO 9001 Certified',
    href: '/credentials/outsourcing-service-provider-iso9001.pdf',
  },
];

export const certifications = [
  {
    key: 'iso27001',
    logo: '/images/credentials/ISO-27001-Logo.webp',
    name: 'ISO 27001:2022',
    authority: 'Bureau Veritas Certification',
    description: 'Certifies our Information Security Management System — your data, IP, and code are protected by internationally recognised security controls.',
    highlights: ['Data & IP protection', 'Access control policies', 'Incident response planning'],
    pdfHref: '/credentials/outsourcing-service-provider-iso27001.pdf',
    color: '#7c3aed',
  },
  {
    key: 'iso9001',
    logo: '/images/cred-iso9001.svg',
    name: 'ISO 9001:2015',
    authority: 'Bureau Veritas Certification',
    description: 'Certifies our Quality Management System — every project follows a structured, audited process for consistent delivery and continual improvement.',
    highlights: ['Structured QA processes', 'Audited delivery workflows', 'Client satisfaction tracking'],
    pdfHref: '/credentials/outsourcing-service-provider-iso9001.pdf',
    color: '#2563eb',
  },
  {
    key: 'nasscom',
    logo: '/images/cred-nasscom.svg',
    name: 'NASSCOM Member',
    authority: 'Natl. Association of Software & Service Companies',
    description: "Membership validates our standing in India's premier technology industry body — a signal of credibility and ethical business practices.",
    highlights: ['Industry-body accredited', 'Ethical practice standards', 'Global tech network'],
    pdfHref: null,
    color: '#0891b2',
  },
  {
    key: 'cii',
    logo: '/images/cred-cii.svg',
    name: 'CII Member',
    authority: 'Confederation of Indian Industry',
    description: "Membership in India's foremost business and industry body, reinforcing our commitment to professional conduct, governance, and innovation.",
    highlights: ['Business excellence standards', 'Professional governance', 'Industry collaboration'],
    pdfHref: null,
    color: '#d97706',
  },
  {
    key: 'stpi',
    logo: '/images/cred-stpi.svg',
    name: 'STPI Registered',
    authority: 'Software Technology Parks of India',
    description: 'Government of India registration confirms we operate within a regulated, export-focused framework — providing clients with legal clarity on offshore engagements.',
    highlights: ['Government of India registered', 'Export-compliant operations', 'Legal offshore framework'],
    pdfHref: null,
    color: '#059669',
  },
  {
    key: 'gdpr',
    logo: '/images/credentials/GDPR-Logo.webp',
    name: 'GDPR Compliant',
    authority: 'General Data Protection Regulation (EU)',
    description: 'Confirms our handling of personal data meets EU data protection law — lawful processing, data minimisation, and clear user consent for every engagement.',
    highlights: ['Lawful data processing', 'Data minimisation practices', 'User consent management'],
    pdfHref: null,
    color: '#1d4ed8',
  },
  {
    key: 'ccpa',
    logo: '/images/credentials/CCPA-Logo.webp',
    name: 'CCPA Compliant',
    authority: 'California Consumer Privacy Act',
    description: "Certifies our practices honour California residents' rights to know, delete, and opt out of the sale of their personal information.",
    highlights: ['Consumer data rights', 'Opt-out mechanisms', 'Transparent data disclosures'],
    pdfHref: null,
    color: '#2563eb',
  },
  {
    key: 'dpdp',
    logo: '/images/credentials/DPDP-Logo.webp',
    name: 'DPDP Certified',
    authority: "Digital Personal Data Protection Act (India)",
    description: "Certifies alignment with India's data protection law — purpose-limited processing and safeguards for personal data across our projects.",
    highlights: ['Purpose-limited processing', 'Data safeguard controls', 'Regulatory alignment'],
    pdfHref: null,
    color: '#1e3a8a',
  },
  {
    key: 'hipaa',
    logo: '/images/credentials/HIPAA-Logo.webp',
    name: 'HIPAA Compliance',
    authority: 'Health Insurance Portability and Accountability Act',
    description: 'Certifies our safeguards for protected health information — critical for clients building healthcare and medical data platforms.',
    highlights: ['Protected health information safeguards', 'Secure data handling', 'Healthcare-grade compliance'],
    pdfHref: null,
    color: '#1e3a8a',
  },
];
